import { createSelector } from 'reselect';

const uiLoading = (state) => state.ui.loading;

export const selectSearchPageLoading = createSelector(
  uiLoading,
  (state) => state.isLoading && state.component === 'searchPage'
);
